// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SENT_EMAILS_TO_USERS = 'massMailing/SENT_EMAILS_TO_USERS';
